import React from 'react';
import { Tag, Avatar, Tooltip } from 'antd';

const ProductImage = ({ product, showTitle }) => {
  if (!product) {
    return null;
  }
  return (
    <Tooltip
      getPopupContainer={() => document.body}
      destroyOnHidden
      placement='top'
      title={
        <div className='w-32 grid gap-2 items-center justify-center'>
          <Avatar
            src={product?.media_file.url}
            alt='Product'
            className='object-cover rounded-md !z-50 m-auto h-full w-20'
          />
          <h5 className='text-center'>{product?.name}</h5>
        </div>
      }
      className='cursor-pointer'
    >
      <Tag className='rounded-md h-6 p-0 flex items-center justify-center m-0 border border-solid border-info-background'>
        <img
          key={product.id}
          src={product?.media_file?.url}
          alt='Product'
          className='object-cover  rounded-sm h-5 !bg-info-background w-8'
        />
        {showTitle && (
          <span
            className='pl-1 text-color-dark-text text-xs max-w-64 font-medium  overflow-hidden text-ellipsis whitespace-nowrap min-w-0 flex-1'
            title={product?.name}
          >
            {product?.name}
          </span>
        )}
      </Tag>
    </Tooltip>
  );
};

export default ProductImage;
